import { JSONSchemaType } from "ajv"
import validateConstant, {
  e入力パターン,
} from "../../../constant/validateConstant"
import util from "../../../ts/util"
import { TSyainRegisterPostReq, TSyainUpdatePutReq } from "./TSyain"

export const TSyainRegisterPostReqSchema: JSONSchemaType<TSyainRegisterPostReq> =
  {
    type: "object",
    properties: {
      社員コード: {
        minLength: 1,
        type: "string",
        maxLength: validateConstant.LENGTH.社員コード,
        pattern: validateConstant.PATTERN.英数字のみ,
        title: "社員コード",
        errorMessage: util.stringErrorMessage("社員コード", {
          required: true,
          maxLength: validateConstant.LENGTH.社員コード,
          pattern: e入力パターン.英数字のみ,
        }),
      },
      社員氏名: {
        type: "string",
        minLength: 1,
        maxLength: validateConstant.LENGTH.一般名称,
        title: "社員氏名",
        errorMessage: util.stringErrorMessage("社員氏名", {
          required: true,
          maxLength: validateConstant.LENGTH.一般名称,
        }),
      },
      社員氏名カナ: {
        type: "string",
        maxLength: validateConstant.LENGTH.一般カナ名称,
        title: "社員氏名カナ",
        nullable: true,
        errorMessage: util.stringErrorMessage("社員氏名カナ", {
          required: false,
          maxLength: validateConstant.LENGTH.一般カナ名称,
        }),
      },
      部所コード: {
        type: "string",
        minLength: 1,
        maxLength: validateConstant.LENGTH.汎用区分コード,
        title: "所属部所",
        nullable: true,
        errorMessage: util.stringErrorMessage("所属部所", {
          required: true,
          maxLength: validateConstant.LENGTH.汎用区分コード,
        }),
      },
      社員区分コード: {
        type: "string",
        minLength: 1,
        maxLength: validateConstant.LENGTH.汎用区分コード,
        title: "社員区分",
        nullable: true,
        errorMessage: util.stringErrorMessage("社員区分", {
          required: true,
          maxLength: validateConstant.LENGTH.汎用区分コード,
        }),
      },
      性別区分コード: {
        type: "string",
        maxLength: validateConstant.LENGTH.汎用区分コード,
        title: "性別区分コード",
        nullable: true,
        errorMessage: util.stringErrorMessage("性別区分コード", {
          required: false,
          maxLength: validateConstant.LENGTH.汎用区分コード,
        }),
      },
      生年月日: {
        type: "string",
        nullable: true,
        title: "生年月日",
        errorMessage: util.stringErrorMessage("生年月日", {
          required: false,
        }),
      },
      血液型区分コード: {
        type: "string",
        maxLength: validateConstant.LENGTH.汎用区分コード,
        title: "血液型区分コード",
        nullable: true,
        errorMessage: util.stringErrorMessage("血液型区分コード", {
          required: false,
          maxLength: validateConstant.LENGTH.汎用区分コード,
        }),
      },
      入社区分コード: {
        type: "string",
        minLength: 1,
        maxLength: validateConstant.LENGTH.汎用区分コード,
        title: "有休付与区分コード",
        nullable: false,
        errorMessage: util.stringErrorMessage("有休付与区分コード", {
          required: true,
          maxLength: validateConstant.LENGTH.汎用区分コード,
        }),
      },
      入社年月日: {
        type: "string",
        minLength: 1,
        nullable: false,
        title: "入社日",
        errorMessage: util.stringErrorMessage("入社日", {
          required: true,
        }),
      },
      請求担当フラグ: {
        type: "number",
        title: "請求担当フラグ",
        enum: [0, 1],
        errorMessage: util.stringErrorMessage("請求担当フラグ", {
          required: false,
        }),
      },
      郵便番号: {
        type: "string",
        maxLength: validateConstant.LENGTH.郵便番号,
        title: "郵便番号",
        nullable: true,
        errorMessage: util.stringErrorMessage("郵便番号", {
          required: false,
          maxLength: validateConstant.LENGTH.郵便番号,
        }),
      },
      住所: {
        type: "string",
        maxLength: validateConstant.LENGTH.住所３,
        title: "住所",
        nullable: true,
        errorMessage: util.stringErrorMessage("住所", {
          required: false,
          maxLength: validateConstant.LENGTH.住所３,
        }),
      },
      電話番号: {
        type: "string",
        maxLength: validateConstant.LENGTH.電話番号,
        title: "電話番号",
        nullable: true,
        errorMessage: util.stringErrorMessage("電話番号", {
          required: false,
          maxLength: validateConstant.LENGTH.電話番号,
        }),
      },
      携帯電話番号: {
        type: "string",
        maxLength: validateConstant.LENGTH.電話番号,
        title: "携帯電話番号",
        nullable: true,
        errorMessage: util.stringErrorMessage("携帯電話番号", {
          required: false,
          maxLength: validateConstant.LENGTH.電話番号,
        }),
      },
      メールアドレス: {
        type: "string",
        maxLength: validateConstant.LENGTH.メールアドレス,
        title: "メールアドレス",
        nullable: true,
        errorMessage: util.stringErrorMessage("メールアドレス", {
          required: false,
          maxLength: validateConstant.LENGTH.メールアドレス,
        }),
      },
      備考: {
        type: "string",
        maxLength: validateConstant.LENGTH.一般テキスト,
        title: "備考",
        nullable: true,
        errorMessage: util.stringErrorMessage("備考", {
          required: false,
          maxLength: validateConstant.LENGTH.一般テキスト,
        }),
      },
      退職年月日: {
        type: "string",
        nullable: true,
        title: "退職年月日",
        errorMessage: util.stringErrorMessage("退職年月日", {
          required: false,
        }),
      },
      退職事由: {
        type: "string",
        maxLength: validateConstant.LENGTH.一般テキスト,
        title: "退職事由",
        nullable: true,
        errorMessage: util.stringErrorMessage("退職事由", {
          required: false,
          maxLength: validateConstant.LENGTH.一般テキスト,
        }),
      },
      ESTRA社員コード: {
        type: "string",
        maxLength: validateConstant.LENGTH.CSVフィールド,
        title: "ESTRA社員コード",
        nullable: true,
        errorMessage: util.stringErrorMessage("ESTRA社員コード", {
          required: false,
          maxLength: validateConstant.LENGTH.CSVフィールド,
        }),
      },
      光英社員コード: {
        type: "string",
        maxLength: validateConstant.LENGTH.CSVフィールド,
        title: "光英社員コード",
        nullable: true,
        errorMessage: util.stringErrorMessage("光英社員コード", {
          required: false,
          maxLength: validateConstant.LENGTH.CSVフィールド,
        }),
      },
    },
    required: ["社員コード", "社員区分コード", "社員氏名", "部所コード"],
  }
export const TSyainUpdatePutReqSchema: JSONSchemaType<TSyainUpdatePutReq> = {
  type: "object",
  properties: {
    社員コード: {
      type: "string",
      minLength: 1,
      maxLength: validateConstant.LENGTH.社員コード,
      pattern: validateConstant.PATTERN.英数字のみ,
      title: "社員コード",
      errorMessage: util.stringErrorMessage("社員コード", {
        required: true,
        maxLength: validateConstant.LENGTH.社員コード,
        pattern: e入力パターン.英数字のみ,
      }),
    },
    社員氏名: {
      type: "string",
      minLength: 1,
      maxLength: validateConstant.LENGTH.一般名称,
      title: "社員氏名",
      errorMessage: util.stringErrorMessage("社員氏名", {
        required: true,
        maxLength: validateConstant.LENGTH.一般名称,
      }),
    },
    社員氏名カナ: {
      type: "string",
      maxLength: validateConstant.LENGTH.一般カナ名称,
      title: "社員氏名カナ",
      nullable: true,
      errorMessage: util.stringErrorMessage("社員氏名カナ", {
        required: false,
        maxLength: validateConstant.LENGTH.一般カナ名称,
      }),
    },
    部所コード: {
      type: "string",
      minLength: 1,
      maxLength: validateConstant.LENGTH.汎用区分コード,
      title: "所属部所",
      nullable: true,
      errorMessage: util.stringErrorMessage("所属部所", {
        required: true,
        maxLength: validateConstant.LENGTH.汎用区分コード,
      }),
    },
    社員区分コード: {
      type: "string",
      minLength: 1,
      maxLength: validateConstant.LENGTH.汎用区分コード,
      title: "社員区分コード",
      nullable: true,
      errorMessage: util.stringErrorMessage("社員区分コード", {
        required: true,
        maxLength: validateConstant.LENGTH.汎用区分コード,
      }),
    },
    性別区分コード: {
      type: "string",
      maxLength: validateConstant.LENGTH.汎用区分コード,
      title: "性別区分コード",
      nullable: true,
      errorMessage: util.stringErrorMessage("性別区分コード", {
        required: false,
        maxLength: validateConstant.LENGTH.汎用区分コード,
      }),
    },
    生年月日: {
      type: "string",
      nullable: true,
      title: "生年月日",
      errorMessage: util.stringErrorMessage("生年月日", {
        required: false,
      }),
    },
    血液型区分コード: {
      type: "string",
      maxLength: validateConstant.LENGTH.汎用区分コード,
      title: "血液型区分コード",
      nullable: true,
      errorMessage: util.stringErrorMessage("血液型区分コード", {
        required: false,
        maxLength: validateConstant.LENGTH.汎用区分コード,
      }),
    },
    入社区分コード: {
      type: "string",
      minLength: 1,
      maxLength: validateConstant.LENGTH.汎用区分コード,
      title: "有休付与区分コード",
      nullable: false,
      errorMessage: util.stringErrorMessage("有休付与区分コード", {
        required: true,
        maxLength: validateConstant.LENGTH.汎用区分コード,
      }),
    },
    入社年月日: {
      type: "string",
      minLength: 1,
      nullable: false,
      title: "入社日",
      errorMessage: util.stringErrorMessage("入社日", {
        required: true,
      }),
    },
    請求担当フラグ: {
      type: "number",
      title: "請求担当フラグ",
      enum: [0, 1],
      errorMessage: util.stringErrorMessage("請求担当フラグ", {
        required: false,
      }),
    },
    郵便番号: {
      type: "string",
      maxLength: validateConstant.LENGTH.郵便番号,
      title: "郵便番号",
      nullable: true,
      errorMessage: util.stringErrorMessage("郵便番号", {
        required: false,
        maxLength: validateConstant.LENGTH.郵便番号,
      }),
    },
    住所: {
      type: "string",
      maxLength: validateConstant.LENGTH.住所３,
      title: "住所",
      nullable: true,
      errorMessage: util.stringErrorMessage("住所", {
        required: false,
        maxLength: validateConstant.LENGTH.住所３,
      }),
    },
    電話番号: {
      type: "string",
      maxLength: validateConstant.LENGTH.電話番号,
      title: "電話番号",
      nullable: true,
      errorMessage: util.stringErrorMessage("電話番号", {
        required: false,
        maxLength: validateConstant.LENGTH.電話番号,
      }),
    },
    携帯電話番号: {
      type: "string",
      maxLength: validateConstant.LENGTH.電話番号,
      title: "携帯電話番号",
      nullable: true,
      errorMessage: util.stringErrorMessage("携帯電話番号", {
        required: false,
        maxLength: validateConstant.LENGTH.電話番号,
      }),
    },
    メールアドレス: {
      type: "string",
      maxLength: validateConstant.LENGTH.メールアドレス,
      title: "メールアドレス",
      nullable: true,
      errorMessage: util.stringErrorMessage("メールアドレス", {
        required: false,
        maxLength: validateConstant.LENGTH.メールアドレス,
      }),
    },
    備考: {
      type: "string",
      maxLength: validateConstant.LENGTH.一般テキスト,
      title: "備考",
      nullable: true,
      errorMessage: util.stringErrorMessage("備考", {
        required: false,
        maxLength: validateConstant.LENGTH.一般テキスト,
      }),
    },
    退職年月日: {
      type: "string",
      nullable: true,
      title: "退職年月日",
      errorMessage: util.stringErrorMessage("退職年月日", {
        required: false,
      }),
    },
    退職事由: {
      type: "string",
      maxLength: validateConstant.LENGTH.一般テキスト,
      title: "退職事由",
      nullable: true,
      errorMessage: util.stringErrorMessage("退職事由", {
        required: false,
        maxLength: validateConstant.LENGTH.一般テキスト,
      }),
    },
    ESTRA社員コード: {
      type: "string",
      maxLength: validateConstant.LENGTH.CSVフィールド,
      title: "ESTRA社員コード",
      nullable: true,
      errorMessage: util.stringErrorMessage("ESTRA社員コード", {
        required: false,
        maxLength: validateConstant.LENGTH.CSVフィールド,
      }),
    },
    光英社員コード: {
      type: "string",
      maxLength: validateConstant.LENGTH.CSVフィールド,
      title: "光英社員コード",
      nullable: true,
      errorMessage: util.stringErrorMessage("光英社員コード", {
        required: false,
        maxLength: validateConstant.LENGTH.CSVフィールド,
      }),
    },
    更新日時: {
      type: "string",
      minLength: 1,
      title: "更新日時",
      errorMessage: util.stringErrorMessage("更新日時", {
        required: true,
      }),
    },
  },
  required: [
    "更新日時",
    "社員コード",
    "社員区分コード",
    "社員氏名",
    "部所コード",
  ],
}
